

















import { Vue, Prop, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import { IS_LOADING } from "@/store/types";
@Component({
  computed: {
    ...mapState(["isLoading"])
  }
})
export default class LoadingPanel extends Vue {}
